module.exports = __webpack_public_path__ + "img/hb.c7df5d1c.png";